import React, { useRef, useEffect } from "react";
import { Banner } from "./Banner";
import { Banner2 } from "./Banner2";

export const GridBanel2 = ({

    banners = [
        { 
            id: "1", 
            image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/cms-banner-02.jpg?v=1720610740", 
            href: "#",
            title: "",
            describe: "Nước ép tươi làm từ khoai tây",
            action: { title: "Xem thêm", href: "#" }
          },
          { 
            id: "2", 
            image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/cms-banner-01.jpg?v=1720610740", 
            href: "#",
            title: "",
            describe: "Nước ép tươi làm từ khoai tây",
            action: { title: "Xem thêm", href: "#" }
          },
       
    ]
}) => {
    const scrollRef = useRef(null);
    // Gắn sự kiện lăn chuột để cuộn ngang
    const handleWheel = (e) => {
        const el = scrollRef.current;
        if (el && e.deltaY !== 0) {
            e.preventDefault();
            el.scrollLeft += e.deltaY;
        }
    };
    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
      
        if (el.scrollWidth > el.clientWidth) {
            el.addEventListener("wheel", handleWheel, { passive: false });

            return () => {
                el.removeEventListener("wheel", handleWheel);
            };
        }
      }, []);
    return (
        <div className="w-full flex justify-center items-center mt-4 overflow-hidden  px-4">
            <div className="no-scrollbar overflow-x-auto w-full " ref={scrollRef}> 
                <div
                  
                   
                    className={`grid grid-cols-2 gap-4  min-w-max lg:w-full xl:w-[--page-width] m-auto`}
                >
                    {banners?.map((b,index) => (
                        <Banner2 key={index} b={b} />
                    ))}
                </div>
            </div>
        </div>
    );
};
